module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wxc-special-rich-text weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.$emit('wxcSpecialRichTextClick')
      }
    }
  }, [_c('div', {
    staticClass: "tag-div weex-ct weex-div",
    style: (_vm._px2rem(Object.assign({
      top: _vm.top + 'px'
    }, _vm.newList[0].tagDivStyle), 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.newList[0] && _vm.newList[0].type === 'icon' && _vm.newList[0].src) ? _c('figure', {
    staticClass: "wxc-image weex-el weex-image",
    style: (_vm._px2rem(_vm.newList[0].style, 75)),
    attrs: {
      "src": _vm.newList[0].src,
      "quality": "original",
      "original": true,
      "aria-hidden": true,
      "data-img-src": _vm.newList[0].src,
      "weex-type": "image",
      "data-evt-load": ""
    },
    on: {
      "load": _vm.onLoad
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newList[0] && _vm.newList[0].type === 'tag' && _vm.newList[0].value) ? _c('wxc-rich-text-tag', {
    attrs: {
      "tag-value": _vm.newList[0].value,
      "tag-theme": _vm.newList[0].theme,
      "tag-style": _vm.newList[0].style
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.newList[0] && _vm.newList[0].type === 'text' && _vm.newList[0].value) ? _c('p', {
    staticClass: " weex-el weex-text",
    class: ['wxc-text', _vm.newList[0].theme],
    style: (_vm._processExclusiveStyle(_vm.newList[0].style, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.newList[0].value))]) : _vm._e(), _vm._v(" "), (_vm.newList[1] && _vm.newList[1].value) ? _c('p', {
    staticClass: " weex-el weex-text",
    class: ['wxc-text', _vm.newList[1].theme],
    style: (_vm._processExclusiveStyle(_vm.newList[1].style, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.newList[1].value))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d86a2ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d86a2ee","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-special-rich-text/index.vue
// module id = 222
// module chunks = 0 1